import * as React from 'react'
import styled, { css } from 'styled-components'
import ReactModal from 'react-modal'

import Icon from '../Icon/Icon'
import Spinner from '../Spinner/Spinner'
import ReferralImage from '../../../assets/img/referral-image.webp'

import media from '../../../services/generateMediaQueries'
import LinkButton from '../LinkButton/LinkButton'

const StyledReactModal = styled(ReactModal)`
  position: absolute;
  top: 0;
  right: 0;
  border: none;
  background: var(--color-bg-light);
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  outline: none;
  width: 100%;
  max-width: 940px;
  height: 100%;
  opacity: 0;
  display: flex;
  flex-direction: column;
  transition: all var(--animation-duration) var(--animation-easing);

  &.ReactModal__Content {
    &--after-open {
      opacity: 1;
      transition: all var(--animation-duration) var(--animation-easing);
    }

    &--before-close {
      opacity: 0;
      transition: all calc(var(--animation-duration) / 2)
        var(--animation-easing);
    }
  }

  ${media.lessThan('small')`
    top: 0;
    right: 0;
    height: 100% !important;
    border-radius: 0;
    max-width: unset;
    max-height: unset;
  `}
`

const DefaultCloseButton = styled.button`
  position: absolute;
  color: var(--color-fg);
  border: 0;
  background-color: transparent;
  top: 15px;
  right: 15px;
  font-size: 30px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.5);
  width: 48px;
  height: 48px;
  padding: 9px;
  border-radius: 100%;
  outline: none;

  z-index: 1;

  ${props =>
    props.zIndex &&
    css`
      z-index: ${props.zIndex + 1};
    `}

  > svg {
    vertical-align: baseline;
  }
`

const LoadingContainer = styled.div`
  min-height: 20rem;
  display: flex;
  align-items: center;
  justify-content: space-around;
`
// Not Found Handling
const FlexWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: center;
  flex-direction: column;
  min-height: 480px;
  padding: 2rem;
  margin: auto;
  max-width: 480px;
`
const Title = styled.h1`
  font-size: 1.5rem;
  text-align: center;
  margin-top: 0;
  color: var(--color-secondary);
  font-weight: var(--font-weight-bold);
`
const BlockButton = styled(LinkButton)`
  width: 100%;
`
const StyledImage = styled.img`
  display: block;
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
`

const overlay = {
  zIndex: 10000,
  background: 'rgba(0, 0, 0, 0.8)',
}

const content = {}

function SideModal(props) {
  const {
    handleClose,
    show,
    loading,
    onClose,
    children,
    CloseButton,
    zIndex,
    shouldCloseOnOverlayClick = true,
    ...restProps
  } = props

  return (
    <StyledReactModal
      isOpen={show}
      style={{
        overlay: {
          ...overlay,
          ...(zIndex ? { zIndex } : {}),
        },
        content,
      }}
      onRequestClose={onClose}
      closeTimeoutMS={150}
      shouldCloseOnOverlayClick={loading ? false : shouldCloseOnOverlayClick}
      bodyOpenClassName="sticky-modal-open"
      htmlOpenClassName="sticky-modal-open"
      {...restProps}
    >
      <DefaultCloseButton zIndex={zIndex} onClick={onClose}>
        <Icon name="x" />
      </DefaultCloseButton>
      {Number(loading) === 4 ? (
        <FlexWrapper>
          <Title>Page Not Found</Title>
          <StyledImage src={ReferralImage} alt="Page Not Found" />
          <BlockButton to="/">Redirect to Main</BlockButton>
        </FlexWrapper>
      ) : loading ? (
        <LoadingContainer>
          <Spinner />
        </LoadingContainer>
      ) : (
        children
      )}
    </StyledReactModal>
  )
}

SideModal.defaultProps = {}

SideModal.propTypes = {}

export default SideModal
